export const API_ENDPOINTS = {
  BASE_URL: 'https://sellerapi.kaufland.com/v2',
  ACCOUNT: '/account/',
  // We can add other endpoints later:
  // PRODUCTS: '/items/',
  // CATEGORIES: '/categories/',
};